<div class="bundle-upload-container landscape-mode">
  <!-- Dialog header with close button -->
  <div class="dialog-header">
    <h2>Upload Files for a New Bundle</h2>
    <button mat-icon-button class="close-dialog-button" (click)="closeDialog()">
      <mat-icon>close</mat-icon>
    </button>
  </div>
  
  <div class="upload-form">
    <!-- Form Fields Row - All form fields in a single row for landscape layout -->
    <div class="form-fields-row">
      <!-- Subject and Section Dropdowns -->
      <div class="form-group">
        <mat-form-field appearance="fill" class="full-width">
          <mat-label>Select Subject</mat-label>
          <mat-select [(ngModel)]="selectedSubject" (selectionChange)="onSubjectChange()">
            <mat-option *ngFor="let subject of subjects" [value]="subject.subject_name">
              {{ subject.subject_name }}
            </mat-option>
          </mat-select>
        </mat-form-field>
      </div>
      
      <div class="form-group">
        <mat-form-field appearance="fill" class="full-width">
          <mat-label>Select Section</mat-label>
          <mat-select [(ngModel)]="selectedSection" [disabled]="!selectedSubject">
            <mat-option *ngFor="let section of sections" [value]="section.section_name">
              {{ section.section_name }}
            </mat-option>
          </mat-select>
        </mat-form-field>
      </div>
      
      <!-- Optional Topic and Subtopic fields -->
      <div class="form-group">
        <mat-form-field appearance="fill" class="full-width">
          <mat-label>Topic (Optional)</mat-label>
          <input matInput [(ngModel)]="topic" placeholder="Enter topic">
        </mat-form-field>
      </div>
      
      <div class="form-group">
        <mat-form-field appearance="fill" class="full-width">
          <mat-label>Subtopic (Optional)</mat-label>
          <input matInput [(ngModel)]="subtopic" placeholder="Enter subtopic">
        </mat-form-field>
      </div>
    </div>
    
    <!-- File Upload Section -->
    <div class="file-upload-section">
      <h3>Upload Files</h3>
      <p class="upload-helper-text">Please upload at least one file. Each file type is optional, but at least one is required.</p>
      
      <div class="file-cards">
        <div *ngFor="let fileType of fileTypes" class="file-card">
          <div class="file-card-header">
            <h4>{{ getFileLabel(fileType) }}</h4>
          </div>
          
          <div class="file-input-container">
            <input type="file" id="file-{{fileType}}" (change)="onFileSelected($event, fileType)" 
              style="display: none;" 
              [accept]="getFileAccept(fileType)">
            
            <div *ngIf="!files[fileType]" class="file-placeholder" (click)="triggerFileInput(fileType)">
              <mat-icon>cloud_upload</mat-icon>
              <p>Click to upload</p>
              <small>{{ getFileExtension(fileType) }}</small>
            </div>
            
            <div *ngIf="files[fileType]" class="file-preview">
              <p class="file-name">{{ files[fileType]?.name }}</p>
              <button mat-icon-button color="warn" (click)="removeFile(fileType)" title="Remove file">
                <mat-icon>close</mat-icon>
              </button>
            </div>
            
            <div *ngIf="fileError[fileType]" class="file-error">
              {{ fileError[fileType] }}
            </div>
          </div>
        </div>
      </div>
    </div>
    
    <!-- Error and Success Messages -->
    <div *ngIf="uploadError" class="error-message">
      <mat-icon>error</mat-icon> {{ uploadError }}
    </div>
    
    <div *ngIf="uploadSuccess" class="success-message">
      <mat-icon>check_circle</mat-icon> Bundle created successfully!
    </div>
    
    <!-- Progress Bar for Upload -->
    <div *ngIf="isSubmitting" class="progress-container">
      <p>Uploading files...</p>
      <mat-progress-bar mode="indeterminate"></mat-progress-bar>
    </div>
    
    <!-- Form Actions -->
    <div class="form-actions">
      <button mat-raised-button color="primary" [disabled]="isSubmitting" (click)="createBundle()">
        Create Bundle
      </button>
      <button mat-button [disabled]="isSubmitting" (click)="resetForm()">
        Reset
      </button>
      <button mat-button [disabled]="isSubmitting" (click)="closeDialog()">
        Cancel
      </button>
    </div>
  </div>
</div> 